<template>
  <div>
    
    <div class="main-banner sec-mt">
      <div class="container">
        <div class="banner-content d-flex justify-content-end" :style="{backgroundImage:`url(${row.image2}) !important`}">
            <!-- <img v-if="row.image2" :src="row.image2" :alt="row.title2"> -->
            <div class="content mbb-content">
              <p class="title" 
                  v-html="row.subTitle2"
                  :style="'color:'+row.subTitleColor2+' !important'">
              </p>
              <p class="head-title"
                  v-html="row.title2"
                  :style="'color:'+row.titleColor2+' !important'">
              </p>
              <router-link v-if="row.button2" :to="row.redirect2" class="btn-primary-o d-inline-block btn-white mg-t">
                  <div class="d-flex align-items-center">
                    {{ row.button2 }} 
                    <span class="icon-arrow-right ml-2"></span>
                  </div>
              </router-link>
            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.btn-white {
  background: #fff;
  color: #000;
  border: none;
  padding: 7px 18px;
}
.icon-arrow-right {
  font-weight: bold;
}
.btn-white:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {}

@media (max-width: 767.98px) {
  .main-banner .banner-content .content .title {
    font-size: 20px;
  }
  .main-banner .banner-content .content .title {
    line-height: 70px;
  }
  .main-banner .banner-content .content .head-title {
        margin-top: 19px;
  }
  .sections .training-center .content .head-title {
    line-height: 1.1;
  }
  .widget-tv {
    flex-wrap: wrap;
  }
  .widget-view {
    height: 100%;
  }
  .mg-t {
    margin-top: 9px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
